import { EventType, User } from "@/types";

import { axios } from "../axios.instance";

export type ApproveParticipantRequest = {
  eventId: EventType["id"];
  applicantId: User["id"];
};

export type ApproveParticipantResponse = unknown;

export const approveParticipant = async (body: ApproveParticipantRequest): Promise<ApproveParticipantResponse> => {
  const { data } = await axios.post(`/events/manage/${body.eventId}/approve`, { applicantId: body.applicantId });

  return data;
};
